import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { IconButton } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    minHeight: 40,
    maxHeight: '100%',
  },
  simpleCell: {
    wordWrap: 'break-word',
  },
  subRow: {
    opacity: 0.7,
  },
  colExpander: {
    width: '30px',
    textAlign: 'center',
    padding: 0,
  }
});

export default function GroupedTable(props) {
  const classes = useStyles();
  const orderBy = props.defaultSort ?? '';
  const columns = props.columns;
  const rows = props.rows;
  const groupBy = props.groupBy;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);

  const groups = rows.reduce((acc, row) => {
    let key = row[groupBy];
    acc[key] = acc[key] || [];
    acc[key].push(row);
    return acc;
  }, {});
  const keys = Object.keys(groups);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function ExpandableRow(props) {
    const data = props.data;
    const columns = props.columns;
    const [expanded, setExpanded] = React.useState(false);
    
    const canExpand = data.length > 1;

    const handleExpandClick = () => {
      setExpanded(expanded => !expanded);
    };

    return (
      <React.Fragment>
        {
          data.map((row, index) => {
            return (
              (index === 0 || (index > 0 && expanded)) ?
                <TableRow key={`row_${index}`} hover
                  className={index > 0 ? classes.subRow : null}>
                  <TableCell
                    key={`cell_expander`}
                    className={classes.colExpander}>
                    {
                      (canExpand && index === 0) ?
                        <IconButton size="small" onClick={() => handleExpandClick()}>
                          {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                      : index > 0 ? '|' : null
                    }
                  </TableCell>
                  {
                    columns.map((column) => {
                      const value = row[column.id];
                      return (<TableCell
                        key={`cell_${column.id}`}
                        className={classes.simpleCell}
                        style={{ maxWidth: column.maxWidth }}>
                        {
                          column.format ? column.format(value) :
                            value + ''}
                      </TableCell>)
                    })
                  }
                </TableRow>
              : null
            )
          })
        }
      </React.Fragment>
    )
  }

  return (
    <Paper>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              <TableCell key='expander' />
              {
                columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, maxWidth: column.maxWidth }}
                    sortDirection={orderBy === column.id ? 'asc' : false}
                  >
                    {column.label}
                  </TableCell>
                ))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {
              keys.map((key) => {
                let data = groups[key];
                return (<ExpandableRow key={key} columns={columns} data={data} />)
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}